module.exports = __webpack_public_path__ + "static/resume_sanitized-81089c9bd458df96685e27df6cc5f6dc.pdf";